module.exports = __webpack_public_path__ + "img/accept.066431e9.png";